import React, { useMemo } from 'react';
import { Redirect, useHistory, RouteComponentProps } from 'react-router-dom';
import { Box, Typography } from '@material-ui/core';

import { AccountForms, FormStatus, sessionService, sessionQuery } from '@lib/state';
import { SignInForm, SignInFormFields, useFormEvents, useObservable } from '@lib/common';
import { CreateAccountWidget } from '../components';

export const SignInPage: React.FC<RouteComponentProps> = ({ location }) => {
  const history = useHistory();

  const [{ status, error }, resetFormUI] = useFormEvents(AccountForms.Login);
  const isLoggedIn = useObservable(sessionQuery.isLoggedIn, 'async');

  const redirectTo = useMemo(() => new URLSearchParams(location.search).get('redirect'), [
    location,
  ]);
  if (isLoggedIn) {
    return <Redirect to={redirectTo ?? '/'} />;
  }

  const onSubmit = ({ username, password }: SignInFormFields) =>
    sessionService.login(username, password);

  const onForgotPasswordRedirect = () => {
    history.push(`/account/forgot`);
  };

  return (
    <Box paddingX={2} marginTop={2}>
      <Typography variant="h5" align="center" color="textSecondary" paragraph>
        Welcome to Armadillo Guest Portal
      </Typography>
      <SignInForm
        buttonColor="secondary"
        onSubmit={onSubmit}
        error={error}
        pending={status === FormStatus.Pending}
        onResetFeedback={resetFormUI}
        usernameLabel="Email"
        onForgotPasswordRedirect={onForgotPasswordRedirect}
      >
        <CreateAccountWidget
          onCreate={() => history.push({ pathname: '/account/create', search: location.search })}
        />
      </SignInForm>
    </Box>
  );
};
